import React from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group"; // ES6

import RedirectTableRow from "./RedirectTableRow";
import styles from "./RedirectsTable.module.css";

function RedirectsTable(props) {
  let { redirects } = props;

  const items = redirects.map((redirect, index) => (
    <CSSTransition
      key={redirect.get("id")}
      classNames="list-animate"
      timeout={{ enter: 600, exit: 600 }}
    >
      <RedirectTableRow key={redirect.get("id")} redirect={redirect} onDelete={props.onDelete} />
    </CSSTransition>
  ));

  return (
    <div className={styles["redirect-table-container"]}>
      <div className={styles["redirect-table-header"]}>
        <div className={styles["header-old"]}>Old Page</div>
        <div className={styles["header-redirect"]}>Redirected To</div>
        <div className={styles["header-delete"]}></div>
      </div>

      <div className={styles["redirect-table-body"]}>
        <TransitionGroup>{items}</TransitionGroup>
      </div>
    </div>
  );
}

export default RedirectsTable;
